import { getDateValue } from './date';

export function getModifiedUser (obj) {
  return obj.createdUserUniqueName || obj.modifiedUserUniqueName;
}

export function getModifiedDate (obj) {
  return getDateValue(obj.createdDate || obj.modifiedDate);
}
